import { atom } from "jotai"
interface PriceChangeState {
  [key: string]: {
    isPositive: boolean
    valueChange: string
    percentChange: string
    oraclePriceChange: string
  }
}

export const priceChangeState = atom<PriceChangeState>({})
